export const tableData = (t) =>[
  {
    name: t('customer.quantityDiscount'),
    dataBase: 'name',
    isMutation: true,
  },
];
